import request from '@/utils/request'

export function getWebRoomConfigApi(query) {
  return request({
    url: '/config-service/v1/web-room-config',
    method: 'get',
    params: query
  })
}

export function addWebRoomConfigApi(payload) {
  return request({
    url: '/config-service/v1/web-room-config',
    method: 'post',
    data: payload
  })
}

export function updateWebRoomConfigApi(id, payload) {
  return request({
    url: `/config-service/v1/web-room-config/${id}`,
    method: 'put',
    data: payload
  })
}

export function deleteWebRoomConfigApi(payload) {
  return request({
    url: '/config-service/v1/web-room-config',
    method: 'delete',
    data: payload
  })
}
